import './StageTag.scss';
import psc from '../../Assets/images/psc_logo.png';
import police from '../../Assets/images/logo.png';
import nig_logo from '../../Assets/images/ng_flag_logo.png';
interface StageTagProps {
  currentCount: number;
}
export default function StageTag (props: StageTagProps) {
  //   const pct = Math.max(0, Math.min(100, (props.currentCount / 4) * 100));
  const proN = props.currentCount - 1;
  return (
    <div className=' '>
      <div className='d-lg-flex d-block justify-content-between'>
           <div className='d-flex justify-content-end d-lg-none'>
          <span className='stage-container'>
            {props.currentCount > 3 ? 'Preview' : `Step ${props.currentCount} of 3`}
          </span>
        </div>
        <div className='d-flex px-5 position-relative v-w'>
          <div className='logo-style'>
            <img src={psc} width={60} height={60} className='rounded-pill' />
            <img src={police} width={60} height={60} className='rounded-pill' />
          </div>
          <div>
            <img
              src={nig_logo}
              width={150}
              height={150}
              className='rounded-pill ms-3'
            />
          </div>
        </div>
        <div className='align-content-center'>
            <h4 className='stage-tag-title text-center  '>
                NIGERIA POLICE FORCE RECRUITMENT PORTAL
            </h4>
        </div>
        <div className='d-none d-lg-block'>
          <span className='stage-container'>
            {props.currentCount > 3 ? 'Preview' : `Step ${props.currentCount} of 3`}
          </span>
        </div>
      </div>
      <div className='d-flex mx-3 my-2 justify-content-center position-relative'>
        {/* First Stage */}
        <h5 className='stage-tag-title d-flex w-auto position-relative'>
          <div className='d-block justify-content-center text-center position-absolute start-0 '>
            <div>
              <i
                className='fa fa-check-circle bg-white p-1 mb-1 progress-bar__icon rounded-pill'
                aria-hidden='true'
              ></i>
            </div>
            <div className=' progress-bar_label'>Candidate Verification</div>
          </div>
          <span className='progress-bar my-2 '>
            <span
              className='progress-fill'
              style={{ width: `${(1 / 1) * 100}%` }}
            ></span>
            {/* <span className='progress-fill' style={ { width: `${pct}%` } }></span> */}
          </span>
        </h5>
        {/* Second Stage */}
        <h5 className='stage-tag-title d-flex w-auto position-relative'>
          <div className='d-block justify-content-center text-center position-absolute start-0 '>
            <>
              {proN > 1
                ? (
                <>
                  <div>
                    <i
                      className='fa fa-check-circle bg-white p-1 mb-1 progress-bar__icon rounded-pill'
                      aria-hidden='true'
                    ></i>
                  </div>
                </>
                  )
                : (
                <div className='spinner-border bg-white spinner_size' role='status'>
                  <span className='sr-only'>Loading...</span>
                </div>
                  )}
              <div className=' progress-bar_label'>Personal information</div>
            </>
          </div>
          <div>
            <span className='progress-bar my-2 '>
              <span
                className='progress-fill'
                style={{ width: `${(proN / 2) * 100}%` }}
              ></span>
              {/* <span className='progress-fill' style={ { width: `${pct}%` } }></span> */}
            </span>
          </div>
        </h5>
        {/* Third Stage */}
        <h5 className='stage-tag-title d-flex w-auto position-relative'>
          <div className='d-block justify-content-center text-center position-absolute start-0 '>
            {proN > 2
              ? (
              <i
                className='fa fa-check-circle bg-white p-1 mb-1 progress-bar__icon rounded-pill'
                aria-hidden='true'
              ></i>
                )
              : proN === 2
                ? (
              <div className='spinner-border bg-white' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
                  )
                : (
              <i
                className='fa fa-upload bg-white p-1 mb-1 progress-bar__icon text-dark rounded-pill'
                aria-hidden='true'
              ></i>
                  )}
            <div className=' progress-bar_label'>Document Upload</div>
          </div>
          <div>
            <span className='progress-bar my-2 '>
              <span
                className='progress-fill'
                style={{
                  width: `${(props.currentCount < 3 ? 0 : proN / 3) * 100}%`,
                }}
              ></span>
              {/* <span className='progress-fill' style={ { width: `${pct}%` } }></span> */}
            </span>
          </div>
        </h5>
        {/* Fourth Stage */}
        <h5 className='stage-tag-title d-flex w-auto position-relative'>
          <div className='d-block justify-content-center text-center position-absolute start-0 mw-100'>
            <div>
              <i
                className='fa fa-check-circle bg-white p-1 mb-1 progress-bar__icon text-dark rounded-pill'
                aria-hidden='true'
              ></i>
            </div>
            <div className=' progress-bar_label'> Application Preview</div>
          </div>
          <div>
            <span className='progress-bar my-2 '>
              <span
                className='progress-fill'
                style={{
                  width: `${(props.currentCount === 4 ? proN / 3 : 0) * 100}%`,
                }}
              ></span>
              {/* <span className='progress-fill' style={ { width: `${pct}%` } }></span> */}
            </span>
          </div>
        </h5>
      </div>
    </div>
  );
}
